/**
 * Configuración de Day.js
 * Configura locale y timezone para toda la aplicación
 */
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import 'dayjs/locale/es';

// Extender dayjs con plugins
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

// Configurar locale español
dayjs.locale('es');

// Configurar timezone por defecto: America/Guayaquil (GMT-5)
dayjs.tz.setDefault('America/Guayaquil');

export default dayjs;
